module.exports = __webpack_public_path__ + "static/img/qtzlpic.504eebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/summary/assets/images/qtzlpic.png
// module id = IPiq
// module chunks = 166